import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule, FlexModule } from "@angular/flex-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatTabsModule } from "@angular/material/tabs";
import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { LeaderboardListModule } from "src/app/shared/component/leaderboard-list/leaderboard-list.module";
import { LeaderboardPodiumModule } from "../leaderboard-podium/leaderboard-podium.module";
import { LeaderboardComponent } from "./leaderboard.component";

@NgModule({
    declarations: [LeaderboardComponent],
    exports: [LeaderboardComponent],
    imports: [
        CommonModule,
        LeaderboardListModule,
        LeaderboardPodiumModule,
        MatIconModule,
        FlexModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatButtonModule,
        TranslateModule,
        MatTabsModule,
        NgxSpinnerModule,
        MatSelectModule
    ]
})
export class LeaderboardModule {}
